import React from 'react';
import cn from 'classnames';

import { Badge as Props, variants, themes, Types } from './badge.types';
import Text from '../text';

const Badge: React.FunctionComponent<Props> & {
  variants: typeof variants;
  themes: typeof themes;
} = ({ content, theme = themes.light, variant = variants.primary }) => (
  <Text
    size={Text.sizes.interface}
    className={cn('badge', `badge--theme-${theme}-${variant}`, {
      'badge--padding-tight': content.type === Types.Icon,
    })}
    tight
  >
    {content.type === Types.Numerical
      ? content.content >= 1000
        ? '999+'
        : content.content
      : content.content}
  </Text>
);

Badge.variants = variants;
Badge.themes = themes;
export default Badge;
